<template>
  <div class="main-container">
    <HeaderText :message="headerMessage" />
    <div class="game-container">
      <transition name="fade">
        <div key="placeholder" v-if="!ready" class="game-placeholder">
          <img
            class="gru-logo"
            src="https://gru-games.s3.eu-west-2.amazonaws.com/assets/img/misc/logo-design.png"
          />
        </div>
        <div key="game" v-else class="game-content">
          <GameContainer
            :content="content"
            @round_started="startGame"
            @game_finished="finishGame"
          />
          <div class="locked-content-blocker" v-if="lockContent && ready">
            <svg width="200" viewBox="0 0 24 24">
              <path :d="mdiLock" />
            </svg>
          </div>
        </div>
      </transition>
    </div>
    <BottomControls :gameStarted="gameStarted" @reset="reset(topicKey)" />
  </div>
</template>

<script>
import GameContainer from '@/components/GameContainer.vue'
import BottomControls from '@/components/BottomControls.vue'
import HeaderText from '@/components/HeaderText.vue'

import { mdiLock } from '@mdi/js'
import Vue from 'vue'

import { getCardsForTopic } from '@/lib/content.js'
import { isSubscriber } from '@/lib/auth.js'
import consoleLog from '@/lib/consoleLog.js'

export default {
  name: 'MainScreen',
  components: { GameContainer, BottomControls, HeaderText },
  data() {
    return {
      headerMessage: '',
      ready: false,
      error: false,
      gameStarted: false,
      lockContent: false,
      gameFinished: false,
      topicKey: undefined,
      mdiLock,
      content: [],
    }
  },
  created() {
    if (Vue.config.gruErrorStatus) {
      this.showError()
      return
    }

    this.topicKey = window.location.hash.replace('#', '')
    if (!this.topicKey) {
      this.headerMessage = 'Please add #odd_one_out__animals to the URL'
      this.ready = true
      return
    }
    this.reset(this.topicKey)

    window.addEventListener('hashchange', () => {
      consoleLog('hashchanged')
      this.topicKey = window.location.hash.replace('#', '')
    })
  },
  methods: {
    startGame() {
      this.headerMessage = 'Choose the odd one out'
      this.gameStarted = true
    },
    finishGame() {
      this.headerMessage = 'Well done! Click "New Game" to play again'
      this.gameFinished = true
    },
    showError() {
      this.headerMessage = 'Error starting game'
      this.error = true
    },
    async reset(topicKey) {
      this.ready = false
      this.headerMessage = 'Loading...'
      this.gameStarted = false
      this.gameFinished = false

      try {
        const { isFreeTopic, content } = (
          await Promise.all([
            getCardsForTopic(topicKey),
            new Promise((resolve) => setTimeout(resolve, 500)),
          ])
        )[0]

        this.content = content
        consoleLog('Loaded content:', content.length, 'items')

        this.ready = true
        this.error = false
        if (isSubscriber || isFreeTopic) {
          this.headerMessage = 'Choose the odd one out'
          this.lockContent = false
        } else {
          this.headerMessage = 'Subscribe for access!'
          this.lockContent = true
        }
      } catch (err) {
        console.error(err)
        this.showError()
      }
    },
  },
  watch: {
    async topicKey() {
      if (this.topicKey) {
        await this.reset(this.topicKey)
      }
    },
  },
}
</script>

<style scoped>
.main-container {
  position: absolute;
  inset: 0px;
  overflow: hidden;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.game-container {
  position: relative;
  width: 100%;
  height: 100%;
  flex: 1;
}

.game-placeholder {
  position: absolute;
  inset: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.game-placeholder img {
  width: 25%;
}

.game-content {
  position: absolute;
  inset: 0px;
}

.locked-content-blocker {
  position: absolute;
  inset: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.locked-content-blocker path {
  stroke: none;
  fill: grey;
  opacity: 0.5;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
</style>
